import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" aria-label="Palestra Silenciosa São Paulo - Tecnologia de Áudio para Eventos">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/img/stib/header-stib-palestra.webp"
          alt="Palestra Silenciosa São Paulo - Evento corporativo com fones de ouvido sem fio para conferências e workshops"
          title="Palestra Silenciosa São Paulo - Tecnologia de Áudio Sem Fio"
          className={`w-full h-full object-cover object-top transition-all duration-1000 ${isLoaded ? 'scale-100 opacity-100' : 'scale-110 opacity-0'}`}
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-secondary/60 via-secondary/40 to-secondary/60 dark:from-black/70 dark:via-black/50 dark:to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto w-full">
        <header>
          <h1 className={`font-heading font-extrabold text-4xl sm:text-5xl md:text-7xl lg:text-8xl text-white mb-3 sm:mb-4 tracking-wide leading-[1.1] transition-all duration-700 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            <span className="block">PALESTRA</span>
            <span className="block">SILENCIOSA</span>
            <span className="block text-3xl sm:text-4xl md:text-6xl lg:text-7xl mt-1">em SÃO PAULO</span>
          </h1>
          <p className={`inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 sm:px-6 md:px-8 py-2 sm:py-2.5 md:py-3 font-heading font-semibold text-sm sm:text-base md:text-xl lg:text-2xl text-white mb-6 sm:mb-8 transition-all duration-700 delay-100 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
            Aluguel de Fones Sem Fio para Eventos Corporativos, Conferências e Festas
          </p>
        </header>
        <p className={`font-body font-light text-base sm:text-lg md:text-2xl lg:text-3xl text-white/90 mb-8 sm:mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed transition-all duration-700 delay-200 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <strong>Tecnologia inovadora</strong> para <strong>eventos corporativos</strong> e <strong>conferências</strong> sem ruído externo
        </p>
        <Link
          to="/contato"
          className={`inline-flex items-center gap-2 sm:gap-3 md:gap-4 bg-primary text-black px-6 sm:px-8 md:px-12 py-3 sm:py-4 md:py-5 rounded-full font-body font-bold text-sm sm:text-base md:text-lg uppercase hover:bg-opacity-90 transition-all hover:scale-105 whitespace-nowrap cursor-pointer duration-700 delay-300 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
          aria-label="Solicitar orçamento para palestra silenciosa em São Paulo"
        >
          SOLICITAR ORÇAMENTO
          <div className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10 flex items-center justify-center bg-white dark:bg-gray-900 rounded-full">
            <i className="ri-arrow-right-line text-black dark:text-primary text-sm sm:text-base md:text-xl" aria-hidden="true"></i>
          </div>
        </Link>
      </div>

      {/* Scroll Indicator */}
      <div className={`absolute bottom-6 sm:bottom-8 md:bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce transition-opacity duration-700 delay-500 ${isLoaded ? 'opacity-100' : 'opacity-0'}`} aria-hidden="true">
        <i className="ri-arrow-down-line text-white text-2xl sm:text-3xl"></i>
      </div>
    </section>
  );
}